/**
 * Format Newsletter data for copying as Markdown
 */
export const formatNewsletterCopy = (data: any): string => {
  if (!data || !data.subject_line) {
    return 'No newsletter content available';
  }

  const sections: string[] = [];

  // Subject Line
  sections.push(`**Subject:** ${data.subject_line}`);

  // Preheader (optional)
  if (data.preheader) {
    sections.push(`**Preheader:** ${data.preheader}`);
  }

  sections.push('');

  // Greeting
  if (data.greeting) {
    sections.push(data.greeting);
    sections.push('');
  }

  // Main Content
  if (data.main_content) {
    sections.push(data.main_content);
    sections.push('');
  }

  // CTA
  if (data.cta) {
    sections.push(data.cta);
    sections.push('');
  }

  // Secondary Content (optional)
  if (data.secondary_content) {
    sections.push(data.secondary_content);
    sections.push('');
  }

  // Closing
  if (data.closing) {
    sections.push(data.closing);
    sections.push('');
  }

  // Footer separator
  sections.push('---');
  sections.push('');

  // Footer
  if (data.footer) {
    sections.push(data.footer);
  }

  return sections.join('\n');
};
